(function(){
  function ready(fn){
    if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function initTilt(){
    var cards = document.querySelectorAll('.gw-card, .gw-duo-card, .gw-scroll-card, .gw-review-card, .gw-spotlight-media');
    cards.forEach(function(card){
      card.addEventListener('mousemove', function(e){
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        var rotX = (y * -6).toFixed(2);
        var rotY = (x * 6).toFixed(2);
        card.style.transform = 'perspective(800px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function(){
        card.style.transform = '';
      });
    });
  }

  function initBackToTop(){
    if(document.querySelector('.gw-back-to-top')) return;
    var btn = document.createElement('button');
    btn.className = 'gw-back-to-top';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);
    window.addEventListener('scroll', function(){
      if(window.scrollY > 500){ btn.classList.add('gw-show'); } else { btn.classList.remove('gw-show'); }
    });
    btn.addEventListener('click', function(){
      window.scrollTo({top:0, behavior:'smooth'});
    });
  }

  function initScrollDots(){
    document.querySelectorAll('.gw-scroll-track').forEach(function(track){
      if(track.dataset.dotsInit) return;
      track.dataset.dotsInit = '1';
      var cards = track.querySelectorAll('.gw-scroll-card');
      if(cards.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'gw-scroll-dots';
      cards.forEach(function(_, i){
        var dot = document.createElement('span');
        dot.className = 'gw-scroll-dot' + (i === 0 ? ' gw-active' : '');
        dot.addEventListener('click', function(){
          cards[i].scrollIntoView({behavior:'smooth', inline:'start', block:'nearest'});
        });
        dots.appendChild(dot);
      });
      track.insertAdjacentElement('afterend', dots);

      var ticking = false;
      track.addEventListener('scroll', function(){
        if(ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          var step = (cards[1].offsetLeft - cards[0].offsetLeft) || 1;
          var index = Math.round(track.scrollLeft / step);
          index = Math.max(0, Math.min(cards.length - 1, index));
          dots.querySelectorAll('.gw-scroll-dot').forEach(function(d, i){
            d.classList.toggle('gw-active', i === index);
          });
          ticking = false;
        });
      });
    });
  }

  ready(function(){
    initTilt();
    initBackToTop();
    initScrollDots();
  });
})();
